import React from 'react';
import autoBind from 'react-autobind';
import UserNotification from './Common/UserNotification.jsx';
import ApplicationActions from '../actions/ApplicationActions';
import ContentService from '../services/ContentService';
import ApplicationErrorNotificationStore from '../stores/ApplicationErrorNotificationStore';
import ErrorHandlerConstants from '../constants/ErrorHandlerConstants';
import Transitions from '../core/Transitions';
import { withRouter } from 'react-router';

function getState() {
  let errorCode = ApplicationErrorNotificationStore.getErrorCode();

  return {
    message: errorCode ? getValidationErrorMessage(errorCode) : '',
    showNotifiction: ApplicationErrorNotificationStore.getShowNotifiction()
  };
}


function getValidationErrorMessage(errorCode) {
  let message = '';
  if (errorCode === ErrorHandlerConstants.ErrorCodes.FMS_SUBMIT) {
    message = ContentService.getContent().offlineApplicationNotification;
  } else {
    var errors = errorCode.split(',');
    errors.map(
      (err) =>
        (message += ErrorHandlerConstants.ErrorCodes[err]?
          ContentService.getContent().applicationSumbitErrorNotifications[
            err.toLowerCase()
          ]:'')
    );
    message +=
      ContentService.getContent().applicationSumbitErrorNotifications
        .generalSubmitError;
  }
  return message || ContentService.getContent().offlineApplicationNotification;
}

class ApplicationErrorNotification extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = getState();
  }
  componentDidMount() {
    ApplicationErrorNotificationStore.addChangeListener(this._onChange);
  }

  componentWillUnmount() {
    ApplicationErrorNotificationStore.removeChangeListener(this._onChange);
  }

  _onChange() {
    this.setState(getState());
  }

  goBackToApplicationForm() {
    ApplicationActions.toggleApplicationSubmitErrorNotification();
    Transitions.forwardFromConfirmDetails(this.props.router, { editMode: true });
}
  toggleNotification() {
    ApplicationActions.toggleApplicationSubmitErrorNotification();
  }
  render() {
    return (
      <UserNotification
        id="applicationErrorNotification"
        className="top-sticky-user-notification"
        message={this.state.message}
        onClick={this.toggleNotification}
        isHidden={!this.state.showNotifiction}
        hideIcon={true}
        showBackButton={true}
        onClickBackButton={this.goBackToApplicationForm}
      />
    );
  }
}

export default withRouter(ApplicationErrorNotification);



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ApplicationErrorNotification.jsx